export const APPROVAL_STATUS = {
    pending: 'PENDING',
    approved: 'APPROVED',
    denied: 'DENIED'
};

export const REQUEST_STATUS = {
    awaitingApproval: 'AWAITING_APPROVAL',
    ordered: 'ORDERED',
    shipped: 'SHIPPED',
    deliveredICC: 'DELIVERED_ICC',
    delivered: 'DELIVERED',
    denied: 'DENIED'
};



/** WEBPACK FOOTER **
 ** ./src/constants/general.js
 **/